<div id="error-container">
  <div id="error-title">
    <h2>{{ title }}</h2>
  </div>
  <div id="error-message">
    <p>{{ message }}</p>
  </div>
</div>
